import { ReactElement } from 'react'
import styles from './LentaItem.module.css'
import oval from './../../../../image/oval.svg'
export const LentaDate = ({text,children, dayWeek}:{text:string,children:ReactElement,dayWeek:string}) =>{
    return(
        <div>
            <div style={{textAlign:"center"}}>
                <div style={{display:"inline-block", marginBottom:"10px"}}>
                <div className={styles.lenta_date}>
                    <div>
                        {dayWeek}
                    </div>
                    <div>
                        <img src={oval}/>
                    </div>
                    <div >
                        {text}
                    </div>
                </div>
            </div>
            </div>
            {children}
        </div>
    )
}